"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DragHandler = function DragHandler() {
  return _react2.default.createElement(
    "g",
    { id: "menu" },
    _react2.default.createElement("rect", { id: "Rectangle-path", x: "0", y: "170", width: "500", height: "20" }),
    _react2.default.createElement("rect", { id: "Rectangle-path", x: "0", y: "310", width: "500", height: "20" })
  );
};

exports.default = DragHandler;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/DragHandler.js
// module id = 2940
// module chunks = 4